var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 41 28","fill":"none"}},[_c('path',{attrs:{"d":"M13.64 1L1 13.64L13.64 26.28"}}),_c('path',{attrs:{"d":"M39.2917 13.5H1.70833"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }